import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'
/** API */
import ProductUsesApi from 'api/setting/default-products/product-use.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  PRODUCT_USE_NAME: ``,
  IS_DUPLICATE_PRODUCT_USE_DETAIL: ``,
  PRODUCT_USE_NAME_STRING_BASE: ``,
  PRODUCT_USE_NAME_STRING_EMPTY: ``,
  PRODUCT_USE_NAME_MAXIMUM_LENGTH: ``,
  PRODUCT_USE_NAME_ANY_REQUIRED: ``,

  PRODUCT_USE_NAME_EN: ``,
  IS_DUPLICATE_PRODUCT_USE_DETAIL_EN: ``,
  PRODUCT_USE_NAME_EN_STRING_BASE: ``,
  PRODUCT_USE_NAME_EN_STRING_EMPTY: ``,
  PRODUCT_USE_NAME_EN_MAXIMUM_LENGTH: ``,
  PRODUCT_USE_NAME_EN_ANY_REQUIRED: ``
}
export default function MedicineUses() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [productUses, setProductUses] = useState([])
  const [productUseId, setProductUseId] = useState(Number)
  const [productUseDetail, setProductUseDetail] = useState('')
  const [productUseDetailEn, setProductUseDetailEn] = useState('')
  const [productUseStatus, setProductUseStatus] = useState('')
  const [textLength, setTextLength] = useState<number>(0)
  const [textLengthEn, setTextLengthEn] = useState<number>(0)
  const [errorName, setErrorName] = useState<any>()
  const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isOpenPageModal, setIsOpenPageModal] = useState(false)


  const loadData = async () => {
    try {
      const resp = await ProductUsesApi.findAll({
        group: 'MEDICINE',
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setProductUses(resp.data)
      } else {
        setProductUses([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    if (!productUseDetail) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_USE_NAME: t('MEDICINE_USE.MESSAGE.PRODUCT_USE_NAME') } })

    dispatch(submitModal())
    const obj_send = {
      "productUseDetail": productUseDetail,
      "productUseDetailEn": productUseDetailEn,
      "group": 'MEDICINE'
    }
    setDisabledSubmit(true)
    ProductUsesApi.create(obj_send)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('MEDICINE_USE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpenPageModal(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_USE.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_USE.MESSAGE.${err.message}`) } })
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!productUseDetail) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_USE_NAME: t(`MEDICINE_USE.MESSAGE.PRODUCT_USE_NAME`) } })

    dispatch(submitModal())
    const obj_send = {
      "productUseDetail": productUseDetail,
      "productUseDetailEn": productUseDetailEn,
      "status": productUseStatus,
      "group": 'MEDICINE'
    }
    setDisabledSubmit(true)
    ProductUsesApi.update(productUseId, obj_send)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`MEDICINE_USE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpenPageModal(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_USE.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_USE.MESSAGE.${err.message}`) } })
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const handleChangeName = (e: any) => {
    setErrorName('')
    const name = e === '' ? '' : String(e)
    const contentLength = name.length

    if (contentLength > 40) {
      setErrorMaxLength(true)
    } else {
      setProductUseDetail(name)
      setTextLength(contentLength)
      setErrorMaxLength(false)
    }
  }
  const handleChangeNameEn = (e: any) => {
    const nameEn = e === '' ? '' : String(e)
    const contentLength = nameEn.length
    if (contentLength > 40) {
      setErrorMaxLength(true)
    } else {
      setProductUseDetailEn(nameEn)
      setTextLengthEn(contentLength)
      setErrorMaxLength(false)
    }
  }

  const resetForm = () => {
    setProductUseId(0)
    setProductUseDetail('')
    setProductUseDetailEn('')
    setProductUseStatus('')
    clearErrorMessage()
    setIsOpenPageModal(false)
    setTextLength(0)
    setErrorMaxLength(false)
    setTextLengthEn(0)
  }

  const onActive = () => {
    if (id) {
      ProductUsesApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('MEDICINE_USE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('MEDICINE_USE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      ProductUsesApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('MEDICINE_USE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('MEDICINE_USE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { productUseId: pdUseId, productUseDetail: pdUseDetail, productUseDetailEn: pdUseDetailEn, status: pdUseStatus } = data
    setProductUseId(pdUseId)
    setProductUseDetail(pdUseDetail)
    setProductUseDetailEn(pdUseDetailEn)
    setProductUseStatus(pdUseStatus)
    setIsOpenPageModal(true)
    handleChangeNameEn(pdUseDetailEn)
    handleChangeName(pdUseDetail)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'productUseDetail', disablePadding: false, label: t('MEDICINE_USE.TABLE.CELL.PRODUCT_USE_NAME') },
    { id: 'productUseDetailEn', disablePadding: false, label: t('MEDICINE_USE.TABLE.CELL.PRODUCT_USE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('MEDICINE_USE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('MEDICINE_USE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { productUseId: pdUseId, productUseDetail: pdUseDetail, productUseDetailEn: pdUseDetailEn, updatedBy, updatedAt, status: pdUseStatus } = objData
    const statusBtnActive = pdUseStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = pdUseStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: pdUseId,
      id: pdUseId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: pdUseDetail },
        { option: 'TEXT', align: 'left', label: pdUseDetailEn },
        { option: 'STATUS', align: 'center', label: pdUseStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.productUseDetail)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`MEDICINE_USE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`MEDICINE_USE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { productUseName: name, status: t(`MEDICINE_USE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('MEDICINE_USE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('MEDICINE_USE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <MainButton
                title={t('MEDICINE_USE.BUTTON.ADD')}
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                onClick={() => setIsOpenPageModal(true)}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={productUses.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
        <PageModal
          isOpen={isOpenPageModal}
          title={productUseId ? t('MEDICINE_USE.TITLE_UPDATE') : t('MEDICINE_USE.TITLE_CREATE')}
          size='XS'
          handleClose={resetForm}
          onCancel={{ onClick: resetForm, title: t('MEDICINE_USE.BUTTON.CANCEL') }}
          onSubmit={{ onClick: productUseId ? submitEdit : submit, title: t('MEDICINE_USE.BUTTON.SAVE'), disabled: disabledSubmit }}
        >
          <Box display="flex" flexDirection="column">
            {productUseId ? <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
              <SwitchButton onChange={() => setProductUseStatus(productUseStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={productUseStatus === 'ACTIVE' ? true : false} />
            </Box> : ''}
            <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${40}`}</Box>
            <TextInput
              onChange={(event) => {
                handleChangeName(event.target.value)
                clearErrorMessage()
              }}
              value={productUseDetail}
              label={t('MEDICINE_USE.INPUT.PRODUCT_USE_NAME')}
              helperText={
                errorMessage.PRODUCT_USE_NAME ||
                errorMessage.IS_DUPLICATE_PRODUCT_USE_DETAIL ||
                errorMessage.PRODUCT_USE_NAME_STRING_BASE ||
                errorMessage.PRODUCT_USE_NAME_STRING_EMPTY ||
                errorMessage.PRODUCT_USE_NAME_MAXIMUM_LENGTH ||
                errorMessage.PRODUCT_USE_NAME_ANY_REQUIRED
              }
              required
            />
            <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px', marginTop: '24px' }}>{`${textLengthEn}/${40}`}</Box>
            <TextInput
              onChange={(event) => {
                handleChangeNameEn(event.target.value)
                clearErrorMessage()
              }}
              helperText={
                errorMessage.PRODUCT_USE_NAME_EN ||
                errorMessage.IS_DUPLICATE_PRODUCT_USE_DETAIL_EN ||
                errorMessage.PRODUCT_USE_NAME_EN_ANY_REQUIRED ||
                errorMessage.PRODUCT_USE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.PRODUCT_USE_NAME_EN_STRING_EMPTY ||
                errorMessage.PRODUCT_USE_NAME_EN_STRING_BASE
              }
              value={productUseDetailEn}
              label={t('MEDICINE_USE.INPUT.PRODUCT_USE_NAME_EN')}
            />
          </Box>
        </PageModal>
      </Box>
    </Box>
  )
}
